"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "useSize", {
    enumerable: true,
    get: function() {
        return useSize;
    }
});
const _react = require("react");
const _Theme = require("../contexts/Theme");
const useSize = (s)=>{
    const theme = (0, _Theme.useTheme)();
    return (0, _react.useMemo)(()=>typeof s === "number" ? s : theme.sizes[s], [
        theme.sizes,
        s
    ]);
};

//# sourceMappingURL=useSize.js.map